import { faArrowUp, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "react-loading-skeleton";
import { Container } from "./styles";

type ConversationsTableProps = {
  loading: boolean;
  chats: any;
  ticketArea: any;
  hasNot: any;
  setKeyData: any;
};

const ConversationsTable: React.FC<ConversationsTableProps> = ({
  loading,
  chats,
  setKeyData,
  ticketArea,
  hasNot,
}) => {
  return (
    <Container>
      <table>
        <thead>
          <tr>
            <th>CONVERSAS</th>
            <th>ÁREA</th>
          </tr>
        </thead>
        <tbody>
          {chats.map((chat: any) => (
            <>
              {loading ? (
                <tr key={chat.id} className="loading">
                  <td>
                    <Skeleton width={130} height={20} />
                  </td>
                  <td>
                    <Skeleton width={80} height={20} />
                  </td>
                  <td>
                    <Skeleton width={20} height={20} />
                  </td>
                </tr>
              ) : (
                <tr
                  key={chat.id}
                  onClick={() => setKeyData("chat", chat)}
                  className={!chat.open ? "closed" : ""}
                >
                  <td>
                    {hasNot(chat.id) && <span className="notification" />}
                    {chat.ticket && (
                      <FontAwesomeIcon
                        icon={faArrowUp}
                        style={{
                          fontSize: 12,
                          color: "grey",
                        }}
                      />
                    )}
                    <span style={{ overflowWrap: "anywhere" }}>
                      {chat.summary}
                    </span>
                  </td>
                  <td>{ticketArea(chat.team)}</td>
                  <td>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </td>
                </tr>
              )}
            </>
          ))}
        </tbody>
      </table>
    </Container>
  );
};

export default ConversationsTable;
